import { Button, Col, Form, Row, Select, InputNumber } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import React from 'react';
import { Customer } from '../../../../../core-module/services/logistics/types';
import { TextAreaWithCharacterCount } from '../../../../../components/TextAreaWithCharacterCount';
import { defaultPortions } from '../../../../../core-module/helpers/defaultPortionHelpers';

const formItemLayout = {
  style: { marginTop: 20 },
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 10 }
  }
};

interface Props {
  readonly form: WrappedFormUtils;
  readonly customer: Customer;
  readonly isSaving: boolean;
  readonly onSaveClick: () => void;
  readonly onHideClick: () => void;
}

const ProfileFormComponent = (props: Props) => {
  const { form, customer, isSaving, onSaveClick, onHideClick } = props;

  return (
    <Form {...formItemLayout}>
      <Form.Item label='Vaste route opmerking'>
        {form.getFieldDecorator('route_remarks', {
          rules: [
            { required: false },
            { max: 200, message: 'De maximale lengte is 200 karakters' }
          ],
          initialValue: customer.routelijst_opmerking ?? ''
        })(<TextAreaWithCharacterCount showCharacterCount rows={4} maxLength={200} />)}
      </Form.Item>
      <Form.Item label='Af te geven maaltijdoverzichten'>
        {form.getFieldDecorator('meal_overview_amount', {
          rules: [{ required: false }],
          initialValue: customer.papieren_week_menu ?? 0
        })(<InputNumber type='number' />)}
      </Form.Item>
      <Form.Item label='Standaard portie'>
        {form.getFieldDecorator('default_portion', {
          rules: [{ required: false }],
          initialValue: defaultPortions.find((p) => p.name === customer.default_portie)?.id
        })(
          <Select<number> placeholder='- Maak een keuze -'>
            {defaultPortions.map((portion) => (
              <Select.Option key={portion.id} value={portion.id}>
                {portion.description}
              </Select.Option>
            ))}
          </Select>
        )}
      </Form.Item>
      <Row>
        <Col xs={{ offset: 4, span: 10 }}>
          <Button style={{ marginRight: 5 }} onClick={onHideClick} loading={isSaving}>
            Annuleren
          </Button>
          <Button type='primary' onClick={onSaveClick} loading={isSaving}>
            Opslaan
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export { ProfileFormComponent };
